import React from 'react';
import { Box, Typography } from '@mui/material';
import ListingVideoEmbeds from './ListingVideoEmbeds';
import ListingAttachments from './ListingAttachments';
import { colors, typography } from '../../../../styles/theme';
import BrandedListingContent from '../../BrandedShareChrome/BrandedListingContent';
import { buildLotUserContentPresentation } from '../../../utils/listingPresentationUtils';
import { hasSharedLotUserContentDisplayData } from '../../../utils/lotUserContentFormUtils';

const SECTION_TITLE_SX = {
  color: 'rgba(255,255,255,0.40)',
  fontSize: '11px',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  fontWeight: 600,
};

/**
 * Contenido del dueño en vistas compartidas.
 * Usa la misma jerarquía marketplace que las cards de lista branded.
 */
const LotUserContentSharedSection = ({
  content,
  lotContext = null,
  accentColor = null,
  embedded = false,
}) => {
  if (!content || !hasSharedLotUserContentDisplayData(content)) return null;

  const presentation = buildLotUserContentPresentation(content, lotContext);
  if (!presentation) return null;

  const videos = Array.isArray(presentation.videos) ? presentation.videos : [];
  const attachments = Array.isArray(presentation.attachments) ? presentation.attachments : [];
  const hasVisibleContent = Boolean(
    presentation.title
    || presentation.description
    || presentation.hero
    || presentation.metas.length > 0
    || presentation.images.length > 0
    || videos.length > 0
    || attachments.length > 0,
  );
  if (!hasVisibleContent) return null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {!embedded && (
        <Typography variant="caption" sx={SECTION_TITLE_SX}>
          Información del usuario
        </Typography>
      )}

      <BrandedListingContent
        title={presentation.title}
        description={presentation.description}
        descriptionClamp={false}
        hero={presentation.hero}
        metas={presentation.metas}
        images={presentation.images}
        accentColor={accentColor}
      />
      {videos.length > 0 && (
        <Box>
          <Typography
            sx={{
              color: colors.textPanelTitle,
              fontSize: '14px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.02em',
              fontFamily: typography.fontFamily.primary,
              display: 'block',
              mb: 1.25,
              lineHeight: '16px',
            }}
          >
            Videos
          </Typography>
          <ListingVideoEmbeds videos={videos} />
        </Box>
      )}
      {attachments.length > 0 && (
        <Box>
          <Typography
            sx={{
              color: colors.textPanelTitle,
              fontSize: '14px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.02em',
              fontFamily: typography.fontFamily.primary,
              display: 'block',
              mb: 1.25,
              lineHeight: '16px',
            }}
          >
            Adjuntos
          </Typography>
          <ListingAttachments attachments={attachments} />
        </Box>
      )}
    </Box>
  );
};

export default LotUserContentSharedSection;
